import { FC } from "react";

import { RideStatusCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const RideStatusCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
}) => {
  return <RideStatusCell status={value} />;
};
